const getDefaultState = () => {
    return {
		preferences: false,
		statistics: false,
		marketing: false
	}
}

const state = getDefaultState()

const getters = {
	canShowVideo: (state) => {
		return (state.preferences && state.statistics && state.marketing)
	},
	canStatistics: (state) => {
		return (state.statistics)
	}
}

const actions = {
	updateConsent({ commit }, consent) {
		commit('updateConsent', consent)
	}
}

const mutations = {
	updateConsent (state, consent) {
		state.preferences = consent.preferences
		state.statistics = consent.statistics
		state.marketing = consent.marketing
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}